import PropTypes from 'prop-types';
import { bounds, readingText } from '../presentation';
import { formatRefDate } from '../../../utils/formatRefDate';

export default function InclinationReading({ sensor, channel }) {
    const value = sensor[channel];
    const valid = value != null && String(value).trim() !== '' && Number.isFinite(Number(value));
    const angle = valid ? Math.max(-45, Math.min(45, Number(value))) : 0;
    const view = channel === 'Value1' ? 'Vessel front view' : 'Vessel side view';
    return <article className="dash-inclination">
        <div><span>{sensor.SensorGroup} · {channel}</span><strong>{readingText(value, sensor, channel)}</strong></div>
        <div className="dash-inclination__ship">
            <span className="dash-inclination__axis dash-inclination__axis--x" aria-hidden="true"><b>X</b></span>
            <span className="dash-inclination__axis dash-inclination__axis--y" aria-hidden="true"><b>Y</b></span>
            <img
                src={channel === 'Value1' ? '/assets/tugboat-heel.png' : '/assets/tugboat-trim.png'}
                alt={`${view}${valid ? ` tilted ${value} degrees` : ''}`}
                style={{ transform: `rotate(${angle}deg)` }}
            />
        </div>
        <footer><span>{sensor.SensorName} · {sensor.SensorCode}</span><span>{bounds(sensor, channel).text}</span><span>{formatRefDate(sensor.RefDate)}</span></footer>
        {channel === 'Value2' && <small>Value3: {readingText(sensor.Value3, sensor, 'Value3')}</small>}
    </article>;
}
InclinationReading.propTypes = { sensor: PropTypes.object.isRequired, channel: PropTypes.oneOf(['Value1', 'Value2']).isRequired };
